import Image from 'next/image';
import React from 'react';
import { totalEarnings } from '../../../assets/icons';
import { DashCard } from '../../elements/card';

const PriceQty = ({ icon, title, price, shadow }) => {
  return (
    <DashCard className={`lg:h-[234px] h-full  w-full  border-[#06193829] rounded-[x]   ${shadow ? shadow : 'shadow-sm'}`}>
      <section className="flex items-start justify-between flex-col h-full   py-3">
        <div className="flex items-center">
          <div className=''>
            <Image src={icon || totalEarnings} />
          </div>
         
          <div className="ml-[.6875rem]">
            <h5 className="text-[18px] font-[400] leading-[28px]">{title || 'Total Earnings'}</h5>
          </div>
        </div>
        
        <div className=' '>
          <h3 className="text-[24px] mt-7 mb-3 font-[400]">{`${price}` || '$50'}</h3>
          <small className="text-[16px] text-neutral-light-50  my-7">
            Updated few mins ago
          </small>
        </div>
      </section>
    </DashCard>
  );
};

export default PriceQty;
